import {
  useRecaptcha
} from "../chunk-O5HX3PKI.mjs";
import "../chunk-LPIRJEMY.mjs";
import {
  __objRest
} from "../chunk-DFMI36TU.mjs";

// src/grecaptcha/WithGrecaptcha.tsx
var WithGrecaptcha = (_a) => {
  var _b = _a, { children } = _b, props = __objRest(_b, ["children"]);
  useRecaptcha(props);
  return children;
};
export {
  WithGrecaptcha,
  useRecaptcha
};
//# sourceMappingURL=index.mjs.map